/**
 * Helper function to safely get a string value (prevents rendering objects in React)
 * Firebase can sometimes return objects where strings are expected, causing React error #300
 */
export const safeString = (value, fallback = '') => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return fallback;
};

export default safeString;
